import type { Paddle, PricePreviewParams } from '@paddle/paddle-js';
import { useEffect, useState } from 'react';
import { paidPro } from './paidTiers';

export type PaddlePrices = Record<string, string>;

export function usePaddlePrices(
  paddle: Paddle | undefined,
  country: string | undefined,
): { prices: PaddlePrices; loading: boolean } {
  const [prices, setPrices] = useState<PaddlePrices>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const month = paidPro.priceId.month;
    const year = paidPro.priceId.year;
    if (!paddle || !month) {
      setLoading(false);
      return;
    }

    const items: PricePreviewParams['items'] = [
      { priceId: month, quantity: 1 },
    ];
    if (year) items.push({ priceId: year, quantity: 1 });

    const request: PricePreviewParams = {
      items,
      ...(country ? { address: { countryCode: country } } : {}),
    };

    setLoading(true);
    paddle
      .PricePreview(request)
      .then((preview) => {
        const next: PaddlePrices = {};
        for (const item of preview.data.details.lineItems) {
          next[item.price.id] = item.formattedTotals.total;
        }
        setPrices(next);
      })
      .catch((err: unknown) => {
        console.warn('[exis] failed to load Paddle prices', err);
        setPrices({});
      })
      .finally(() => setLoading(false));
  }, [paddle, country]);

  return { prices, loading };
}
